<template>
  <div>


    <div class="seldashboardRow row">

      <div class="col-xl-3 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="stat-widget-one">
              <div class="stat-icon dib"><i class="ti-cloud text-success border-success"></i></div>
              <div class="stat-content dib">
                <div class="stat-text">{{companyName}}</div>
                <div class="stat-digit"></div>
              </div>
            </div>
          </div>
        </div>
      </div>


      <div class="col-xl-3 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="stat-widget-one">
              <div class="stat-icon dib"><i class="ti-user text-primary border-primary"></i></div>
              <div class="stat-content dib">
                <div class="stat-text">{{$t('seldashboard.totalBuyers')}}</div>
                <div class="stat-digit">{{totalBuyers}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="stat-widget-one">
              <div class="stat-icon dib"><i class="ti-layout-grid2 text-warning border-warning"></i></div>
              <div class="stat-content dib">
                <div class="stat-text">{{$t('seldashboard.totalProducts')}}</div>
                <div class="stat-digit">{{totalProducts}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-3 col-lg-6">
        <div class="card">
          <div class="card-body">
            <div class="stat-widget-one">
              <div class="stat-icon dib"><i class="ti-layout-grid2 text-danger border-danger"></i></div>
              <div class="stat-content dib">
                <div class="stat-text">{{$t('seldashboard.totalStores')}}</div>
                <div class="stat-digit">{{totalStores}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>


    </div>



  </div>


</template>

<script>
  // @ is an alias to /src
  import LeftMenu from '@/components/LeftMenu.vue';
  import HeaderSearch from '@/components/HeaderSearch.vue';
  import HeaderNotification from '@/components/HeaderNotification.vue';
  import HeaderMessages from '@/components/HeaderMessages.vue';
  import User from '@/components/User.vue';
  import LngChooser from '@/components/LngChooser.vue';
  import Breadcrumbs from '@/components/Breadcrumbs.vue';
//  import HelloI18n from '@/components/HelloI18n.vue';
  import MenuToggle from '@/components/MenuToggle.vue';
  import Api from '@/api/Api';
  import Helper from '@/helper/Helper';
  import moment from 'moment';

  export default {
    name: 'CloudDashboard',
    data(){
      return {
        moduleRights: []
        , moduleRightsIds: []

        , companyName: ""
        , actualDayIncome: ""
        , actualDayIncomeByCash: ""
        , actualDayIncomeByCard: ""
        , lastMonthIncome: ""
        , actualMonthIncome: ""
        , lastThreeMonthGrowing: ""

        , totalBuyers: ""
        , totalProducts: ""
        , totalStores: ""
        , totalUsers: ""

        , store: ""
        , stores: ""
        , storeOptions: ""

        , selectStore: ""
        , selectedStore: ""
        , storeName: ""
        , storeLastMonthIncome: ""
        , storeActualDayIncome: ""
        , storeActualDayIncomeByCash: ""
        , storeActualDayIncomeByCard: ""
        , storeActualMonthIncome: ""
        , lastLogin: []
        , Helper: Helper

      }
    },
    mounted() {
      const modul = this;
      modul.moduleRights = modul.$store.state.moduleRights;
      modul.roles = [2, 3, 4, 5, 6, 7, 8, 9, 10];
      const role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
      if (!Helper.checkRoles(modul.roles, role)) {
console.log("redirect login from cloudDashbord")
        modul.$router.push({name: "login"})
      }
      modul.getSelDashboardData();
    },
    watch: {
      selectedStore: function (newStore, oldStore) {
        const modul = this;
        modul.refreshStoreStat(newStore);
      },
      '$store.state.user': function (newVal, oldVal) {

        const modul = this;
        const user_role = (modul.$store.state && modul.$store.state.user && modul.$store.state.user.role) ? modul.$store.state.user.role : 0;
        modul.user_role=user_role;
      },
      '$store.state.moduleRights': function (newVal, oldVal) {
        const modul = this;
        modul.moduleRights = newVal;

        if (Array.isArray(modul.moduleRights)) {
          modul.moduleRightsIds = [];
          modul.moduleRights.forEach(function (e, i) {
            if (Number(e.id_rights) > 0) {
              modul.moduleRightsIds.push(e.modulid)
            }
          })
        }
      },
    },
    methods: {
      getSelDashboardData(){
        const modul = this;
        const data = {};
        Api.getSelDashboardData(data).then(function (res) {
          if (res && res.result) {
            modul.companyName = res.companyName;
            modul.lastMonthIncome = res.lastMonthIncome;
            modul.actualDayIncome = res.actualDayIncome;
            modul.actualDayIncomeByCash = res.actualDayIncomeByCash;
            modul.actualDayIncomeByCard = res.actualDayIncomeByCard;
            modul.actualMonthIncome = res.actualMonthIncome;
            modul.lastThreeMonthGrowing = res.lastThreeMonthGrowing; // in Percentage
            modul.totalBuyers = res.totalBuyers;
            modul.totalProducts = res.totalProducts;
            modul.totalStores = res.totalStores;
            modul.totalUsers = res.totalUsers;
          }
        });
        Api.getStores().then(function (res) {
          if (res && res.result) {
            modul.stores = res.data;
            if (!modul.store) {
              modul.store = (modul.stores[0]) ? modul.stores[0] : {};
              modul.selectedStore = (modul.stores[0] && modul.stores[0].id) ? modul.stores[0].id : 0;
            }
            modul.storeOptions = modul.generateOptions(modul.stores);
            modul.refreshStoreStat();
          }
        });
      },
      refreshStoreStat(newStore){
        const modul = this;
        let id = (modul.store.id) ? modul.store.id : 0;
        if (newStore) {
          id = newStore;
        }
        const data = {id_store: id};
        data.todayfrom = moment.utc().format('YYYY-MM-DD 00:00:00');
        data.todayto = moment.utc().add(1, 'days').format('YYYY-MM-DD 00:00:00');
        Api.getSelStatByStore(data).then(function (res) {
          if (res && res.result) {
            modul.storeName = res.storeName;
            modul.storeLastMonthIncome = res.lastMonthIncome;
            modul.storeActualDayIncome = res.actualDayIncome;
            modul.storeActualDayIncomeByCash = res.actualDayIncomeByCash;
            modul.storeActualDayIncomeByCard = res.actualDayIncomeByCard;
            modul.storeActualMonthIncome = res.actualMonthIncome;
            modul.lastLogin = res.lastLogin;
          }
        });
      },
      generateOptions(stores){
        const ret = [];
        if (Array.isArray(stores)) {
          stores.forEach(function (e) {
            const retElement = [];
            retElement['value'] = e.id;
            retElement['text'] = e.text;
            ret.push(retElement);
          })
        }
        return ret;
      },
    },
    components: {
      LeftMenu,
      HeaderSearch,
      HeaderNotification,
      HeaderMessages,
      User,
      LngChooser,
      Breadcrumbs,
//      HelloI18n,
      MenuToggle
    },
  };
</script>

<style scoped>
  .seldashboardRow .card {
    min-height: 100px;
  }
</style>






